import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faTrash,
    faPlus,
    faEdit,
    faEraser,
    faBars,
    faMoon,
    faTasks,
    faMinus,
    faStar,
    faCalculator,
    faTable
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(faTrash, faPlus, faEdit, faEraser, faBars, faMoon, faTasks, faMinus, faStar, faCalculator, faTable)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
